import {BaseConfig} from "../../infrastructure/config/base-config";
import {OddsByWidgetTerms} from "./odds-by-widget.terms";
import {APP} from "../../core/app/consts";

export class OddsByWidgetConfig extends BaseConfig {
  source: APP.ANALYTICS.SOURCES;

  static injectables = [OddsByWidgetTerms];

  constructor(terms: OddsByWidgetTerms) {
    super('oddsByWidget', null, terms);

    this.source = APP.ANALYTICS.SOURCES.oddsBy;
  }
}
